import { configureStore, combineReducers } from '@reduxjs/toolkit';
import * as auth from './auth';
import * as login from './login';
import * as logout from './logout';
import * as password from './password';
import * as registration from './registration';

const reducer = combineReducers({
  auth: auth.reducer,
  logout: logout.reducer,
  password: password.reducer,
  login: login.reducer,
  registration: registration.reducer,
});

const middlewares = [
  auth.middleware,
  logout.middleware,
  password.middleware,
  ...login.middleware,
  registration.middleware,
];

export const store = configureStore({
  reducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware().concat(middlewares),
});
